import React from 'react';
import './spinner-style.css';

const SearchSpinner = () => {
  return (
    <div className='search-spinner'>
      SPINNING!
    </div>
  )
}

export default SearchSpinner;



/** WEBPACK FOOTER **
 ** ./src/components/SearchSpinner/index.js
 **/